export const ShiftTypeOptions = {
  default: 'default',
  custom: 'custom',
} as const

export type ShiftType = 'default' | 'custom' | undefined
